import { useTheme } from "styled-components";

import { IconProps } from "@/types/iconTypes";

const FilterIcon = ({ color = "black", ...props }: IconProps) => {
  const { colors } = useTheme();

  return (
    <svg
      width={19}
      height={19}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.07414 2.42682L2.07411 2.42679C1.91773 2.27041 2.0292 2 2.25087 2H16.7492C16.9704 2 17.0828 2.26999 16.926 2.4268L16.926 2.42681L11.1464 8.20712L11 8.35357V8.56065V16.7494C11 16.9499 10.7723 17.0702 10.6066 16.9542L10.6066 16.9541L8.10667 15.2048C8.03979 15.158 8 15.0815 8 15V8.56065V8.35357L7.85358 8.20713L2.07414 2.42682Z"
        stroke={colors[color].normal}
        strokeWidth={1.2}
      />
    </svg>
  );
};

export default FilterIcon;
